import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import styles from './style.css'
import {
  categoriesRequest,
  onClickRow,
  onClickAssignToItem
} from 'actions/library/category'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  render () {
    let {categories, categoryDetail} = this.props

    return (
      <div className={styles.wrapper}>
        {categories.length > 0 &&
          <div className={styles['div-table']}>
            <table className={styles['table-header']}>
              <thead>
                <tr>
                  <th className={styles.name}>
                    Category Name
                  </th>
                  <th className={styles.stocks}>
                    Item Stocks
                  </th>
                  <th className={styles.assign} />
                </tr>
              </thead>
            </table>
            <div className={styles['table-content-wrapper']}>
              <InfiniteScroll
                pageStart={1}
                loadMore={this._onReachBottom}
                hasMore={this._hasMore()}
                useWindow={false}
                threshold={10}
                initialLoad={false}>
                <table className={styles['table-content']}>
                  <tbody>
                    {categories.map((category) => {
                      return (
                        <tr className={(categoryDetail && (category.id === categoryDetail.id)) ? styles.selected : ''}
                          onClick={() => this._onClickRow(category)}>
                          <td className={styles.name}>
                            {category.name}
                          </td>
                          <td className={styles.stocks}>
                            {this._categoryItemStockFormatter(category)}
                          </td>
                          <td className={styles.assign}>
                            <a
                              className='btn btn-default btn-sm'
                              onClick={(event) => this._onClickAssignToItem(event, category)}>
                              Assign To Item
                            </a>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        }
      </div>
    )
  }

  _onReachBottom = () => {
    let {dispatch, currentPage, categories} = this.props
    dispatch(categoriesRequest({with_items: true, page: currentPage + 1}, categories))
  }

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _categoryItemStockFormatter = (category) => {
    let total = 0
    if (category.items) {
      total = category.items.length || 0
    }
    return total + ' items'
  }

  _onClickRow = (category) => {
    let {isDirtyCategory} = this.props
    if (isDirtyCategory) {
      this.props.dispatch(askConfirmAction(onClickRow(category)))
    } else {
      this.props.dispatch(onClickRow(category))
    }
  }

  _onClickAssignToItem = (event, category) => {
    event.preventDefault()
    event.stopPropagation()
    this.props.dispatch(onClickAssignToItem(category))
  }
}

function mapStateToProps (state) {
  let {categories, categoryDetail, currentPage, totalPage} = state.library.category
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    categories,
    categoryDetail,
    currentPage,
    totalPage,
    showLoadingSpinnerPage,
    isDirtyCategory: isDirty('category')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  categories: React.PropTypes.array,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  categoryDetail: React.PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Library/Category/List/List.js